export const formatIrdNumber = (event: any) => {
    
    // check to see if the ird number is all numbers and 8-9 in length
    if (event.target.value) {
        return formatIrdNumberString(event.target.value);
    } else {
        return event.target.value;
    }
};

export function formatIrdNumberString(irdNumber: string){
    const pattern = /^[\d]{8,9}$/g;
    if(irdNumber && irdNumber.replace(/\s/g, "").match(pattern)){
        const reversedIrd = [...irdNumber.replace(/\s/g, "")].reverse().join('');
        
        let formattedIrd = reversedIrd.slice(0, 3) + '-' + reversedIrd.slice(3, 6) + '-' + reversedIrd.slice(6, reversedIrd.length);
        formattedIrd = [...formattedIrd].reverse().join('');
        
        return formattedIrd;
    }else{
        return irdNumber;
    }
}